// 语言 地区等其他map
// TODO map 使用 LocalEum为 key

export enum LocalEum {
  HK = 'HK',
  JP = 'JP',
  KR = 'KR',
  US = 'US',
  TW = 'TW',
  MO = 'MO',
  SG = 'SG',
  MY = 'MY'
}

export const currentSymbolMap = {
  HK: 'HK$',
  CN: 'HK$',
  US: 'US$',
  TW: 'US$',
  MO: 'US$',
  JP: '￥',
  KR: 'KRW',
  SG: '$',
  MY: 'US$'
}

export const phoneCodeMap = {
  HK: 852,
  MO: 853,
  TW: 886,
  SG: 65,
  MY: 60,
  US: 1
}

export const emailMap = {
  HK: 'customer@poizon.com',
  MO: 'customer_mo@poizon.com',
  TW: 'customer_tw@poizon.com',
  JP: 'customer-jp@poizon.com',
  US: 'customer_us@poizon.com'
}

export const enMonthArr = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]
